<!--
 * @FileDescription: 商品管理的全部分类（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-06-22（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>

      <div class="tree-goods" v-if="tabIndex == 1">
          <div class="manage-left-top" >
              全部分类
              <img src="@/assets/image/add_shop_manage@2x.png" class="tree-add-one"  id="tree-add-one" @click="onAddManage(1)"/>
          </div>
          <div class="manage-tree div-overflow" >
              <treeShopTem  :treeIndex="tabIndex" ref="treeShopTem"></treeShopTem>
          </div>
          <div class="manage-comp" @click="onChangeTab(2)">编辑完成</div>
      </div>
      <div class="tree-goods" v-if="tabIndex == 2" >
          <div class="manage-left-top" @click="onSelectAll">
              全部分类
          </div>
          <div class="manage-tree div-overflow">
              <treeShopTem ref="treeShopTem" :treeIndex="tabIndex" @onSelectKey="onSelectKey"></treeShopTem>
          </div>
          <div class="manage-comp" @click="onChangeTab(1)">编辑分类</div>
      </div>
      <div class="tree-goods" v-if="tabIndex == 3" >
          <div class="manage-left-top" @click="onSelectAll">
              全部分类
          </div>
          <div class="manage-tree div-overflow">
              <treeShopTem ref="treeShopTem" :treeIndex="2" @onSelectKey="onSelectKey"></treeShopTem>
          </div>
      </div>
  </div>
</template>
<script>
import {getPageAccount} from "@/utils/api";
import treeShopTem from './treeShopTemcloud'
import {mixins} from "@/mixins/mixins";
export default {
    mixins:[mixins],
    props:{
      index:{
          type:Number,
          default:2
      }
    },
    data(){
        return{
            tabIndex:2,
        }
    },
    watch: {
        index(){
            this.tabIndex = this.index
        }
    },
    mounted () {
        this.tabIndex = this.index
    },
    created () {

    },
    components: {
        treeShopTem,
    },
    methods: {
        /**
         * @description: 编辑状态切换（方法描述）
         */
        onChangeTab(index){
            this.tabIndex = index
            if(index == 2){
                this.$refs.treeShopTem.closeIconBlock()
            }
        },
        /**
         * @description: 添加一级分类（方法描述）
         */
        onAddManage(index){
            console.log($('.tree-add-one')[0].offsetLeft,$('.tree-add-one')[0].offsetTop)
            this.$refs.treeShopTem.onAddManage(index,{
                x:$('.tree-add-one')[0].offsetLeft,
                y:$('.tree-add-one')[0].offsetTop
            })
        },
        onSelectKey(values){
            this.$emit('onSelectKey',values)
        },
        onSelectAll(){
            this.$emit('onSelectKey','')

        },
        getOnRefsh(){
          this.$refs.treeShopTem.getList()
        },
    },

}
</script>
<style scoped lang="scss">
    .manage-comp{
        width: 90px;
        height: 32px;
        background: #FAFAFA;
        border: 1px solid #E6E6E6;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--co);
        cursor: pointer;

    }
    .tree-goods{
        display: flex;
        flex-direction: column;
        height: calc(100vh - 400px);
    }
    .manage-tree{
        flex: 1;
        margin-bottom: 10px;
        overflow: auto;
        overflow-x: hidden;
    }
    .manage-left-top{
        cursor: pointer;
        color: #333333;
        font-size: 16px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        img{
            width: 16px;
            margin-left: 5px;
        }
    }
</style>
